import * as React from 'react'

import { useState } from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'item'

/**
 * This is the component description.
 */
const Item = ({
  id,
  className:userClassName,
  style,
  question,
  children,
  titleAs:TitleElement,
}) => {
  const isServer = typeof window === 'undefined'
  const [open, setOpen] = useState(isServer)

  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
    >
      <div
        className="question-container"
        role="button"
        onClick={() => setOpen(!open)}
        onKeyDown={() => setOpen(!open)}
        tabIndex={0}
      >
        <TitleElement
          className="question"
          itemProp="name"
        >
          {question}
        </TitleElement>
        <span
          className={`icon ${open && styleNames.modifierOpen}`}
        >
          +
        </span>
      </div>
      <div
        className={`answer ${open && styleNames.modifierOpen}`}
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
      >
        <div
          itemProp="text"
        >
          {children}
        </div>
      </div>
    </div>
  )
}

Item.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The question to display
   */
  question:PropTypes.string,

  /**
   * The children jsx
   */
  children:PropTypes.node,

  /**
   * The HTML tag to use for the title
  */
  titleAs:PropTypes.string,
}

Item.defaultProps = {
  titleAs:'p',
}

export default Item
